import { render, staticRenderFns } from "./volunteerRegistration.vue?vue&type=template&id=7684e5ac&scoped=true"
import script from "./volunteerRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./volunteerRegistration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./volunteerRegistration.vue?vue&type=style&index=0&id=7684e5ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7684e5ac",
  null
  
)

export default component.exports